export default __webpack_public_path__ + "static/media/fire.9294f851.svg";